import React, { useContext, useState, useEffect } from 'react';
import { LocalizationContext } from '../../../contexts';
import './index.scss';

const VideoUploader = ({videoUrl, onChange, prefix }) => {
    const [localization] = useContext(LocalizationContext);
    const [isDragging, setIsDragging] = useState(false);
    const [error, setError] = useState(false);
    const [timer, setTimer] = useState(false);

    useEffect(() => {
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);

    const showError = (errorMas) => {
        setError(errorMas);
        setTimer(setTimeout(() => {
            setTimer(false);
            setError(false);
        }, 2000));
    };

    const isDraggingOn = () => {
        setIsDragging(true);
    };
    const isDraggingOff = () => {
        setIsDragging(false);
    };

    const uploadFile = (files) => {
        if (!files || files.length !== 1) {
            showError(localization.labels.videoUploader.select_one_video);
            return;
        }

        var file = files[0];
        var fileSize = file.size ? file.size : 0;
        var fileType = file.type ? file.type.toLowerCase() : "";

        if (fileSize > 10 * 1024 * 1024) { // 10MB
            showError(localization.labels.videoUploader.max_file_size);
            return;
        }
        if (["video/mpeg", "video/ogg", "video/ogv", "video/mp4", "video/x-msvideo", "video/x-matroska", "video/webm", "video/x-ms-wmv", "video/quicktime", "application/metastream", "video/avchd-stream", "video/mts", "video/vnd.dlna.mpeg-tts", "video/mp2t"].indexOf(fileType) < 0) {
            showError(localization.labels.videoUploader.unsupported_file_format);
            return;
        }

        window.cet.microservices.nairobiapi.fileUpload.upload({
          container: 'uploads',
          prefix: prefix + '/video',
          file: file
      }).then(url => {
        onChange(url);
      });

      // var reader = new FileReader();
      // reader.onloadend = () => {
      //  onChange(reader.result);
      // };
      // reader.readAsDataURL(file);
    };

    const removeFile=(e) =>{
      e.stopPropagation();
      onChange("");
    }

    return (
      <div className="app-uploader app-uploader--video">
        <div className="app-uploader--video-dropzone"
                data-isdragging={isDragging ? 1 : 0}
                onDragEnter={isDraggingOn}
                onDragOver={isDraggingOn}
                onDragLeave={isDraggingOff} onDrop={(e) => {
                    isDraggingOff();
                    uploadFile(e.dataTransfer.files);
                }}
                onClick={() => {
                    var inputFile = document.createElement("input");
                    inputFile.type = "file";
                    inputFile.accept = ".mp4, .ogv, .wmv, .mov, .webm, .avi, .mts, .m2ts";
                    inputFile.onchange = function (e) {
                        uploadFile(e.target.files);
                    };
                    inputFile.click();
                }}
            >

          <div className="app-uploader--video-drag">
            {!error && <span><div className="k-icon k-i-upload"></div>{localization.labels.videoUploader.choose_video}</span>}
          </div>
          <div className="app-uploader--video-error">{error && <span><div className="k-icon k-i-exception"></div>{error}</span>}</div>
          {videoUrl && <button className="app-uploader--video-delete k-icon k-i-delete" onClick={(e)=>{removeFile(e)}}></button>}
        </div>
        {videoUrl && <div className="app-uploader--video-preview"><video src={videoUrl} controls></video></div>}
        <div className="k-form-hint k-text-start">{localization.labels.videoUploader.hint}</div>
    </div>
    );
};

export default VideoUploader;